/**
 * The console is the part of the screen you can see — never more.
 *
 * It was 100vh tall (owner, 2026-10-04: 「点击进入聊天后下面输入的就不见了 往下滑
 * 上面又不见了」). On a phone 100vh is the screen with the browser's address bar
 * hidden, so while the bar showed, the page ran one bar's height past the bottom:
 * the chat's typing box sat under the edge, and scrolling down to reach it
 * scrolled the chat's header off the top instead.
 *
 * The visible part is what the browser calls the visual viewport. Its height,
 * written to --vv-h, is what .app is sized to (styles.css, html.vv): the address
 * bar coming and going, Android's keyboard (interactive-widget=resizes-content
 * in index.html) and an iPhone's keyboard — which covers the page rather than
 * shrinking it, and slides the visible part down it, so --vv-top follows that —
 * all leave the header at the top and the typing box right above the keyboard.
 */
let tracking = false;

/**
 * An iPhone zooms the whole page in when a box with text under 16px is
 * tapped, and leaves it there, half off the screen. maximum-scale=1 stops
 * that and nothing else: Safari ignores it for a pinch, so people can still
 * zoom. Not on Android, where it would stop the pinch too. (Making every box
 * 16px instead pushed the small ones' words out of them: 「+ 标签」.)
 */
function noTapZoomOnIPhone(): void {
  const ios = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (ios && meta && !/maximum-scale/.test(meta.content)) meta.content += ", maximum-scale=1";
}

export function trackViewport(): void {
  noTapZoomOnIPhone();
  const vv = window.visualViewport;
  if (!vv || tracking) return; // too old to say: 100dvh, then 100vh, in the stylesheet
  tracking = true;
  const root = document.documentElement;
  let frame = 0;
  const apply = () => {
    frame = 0;
    // Pinched in, the visible part is a magnified corner of the page, not a
    // smaller screen: the app keeps its size and the pinch zooms over it.
    if (Math.abs(vv.scale - 1) > 0.01) return;
    root.style.setProperty("--vv-h", `${Math.round(vv.height)}px`);
    root.style.setProperty("--vv-top", `${Math.round(vv.offsetTop)}px`);
  };
  const soon = () => {
    if (!frame) frame = requestAnimationFrame(apply);
  };
  vv.addEventListener("resize", soon);
  vv.addEventListener("scroll", soon);
  // A frame never comes while the tab is hidden; coming back measures again.
  document.addEventListener("visibilitychange", () => !document.hidden && apply());
  apply();
  root.classList.add("vv");
}
